import owlCarousel from 'owl.carousel';
import moment from 'moment-timezone';

import './vendors/datepicker';
import {
    setSameHeights,
    affixCalendar,
    affixBtn,
    findGetParameter,
    updateQueryStringParam,
    formDate,
    ifDateIsBetween
} from './functions/commons';

moment.locale('de');
moment.tz.setDefault('Europe/Berlin');

(function ($) {

    var addToDataLayer = function (event, payload) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': event,
            'payload': payload,
            _clear: true
        });
    }

    $(function () {
        $('a[href*="#"]:not([href="#"])').click(function () {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000);
                    return false;
                }
            }
        });
    });

    $(window).scroll(function () {
        affixCalendar();
        affixBtn();
    });

    $(window).on('load', function () {
        setSameHeights();
    });

    $(window).resize(function () {
        setSameHeights();
        affixCalendar();
        affixBtn();
        $.each($('.bk_panel'), function () {
            $(this).parent().css('height', $(this).outerHeight(true));
        });
    });

    $(document).ready(function () {
        let urlDate = findGetParameter('date');
        const hasDateInUrl = findGetParameter('date');
        if(typeof date === 'undefined' && window.suspendedTo && window.suspendedTo !== 'null' && hasDateInUrl === null) {
            urlDate =  moment(window.suspendedTo, "DD-MM-YYYY").add(1, 'd').format("DD-MM-YYYY");
        }

        let urlEvent = findGetParameter('event');
        let isInsider = findGetParameter('mitarbeiter');

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            $('.socialsharing-whatsapp').css('display', 'inherit');
        }

        var items = $('.bk_teaser_slider .item');
        if (items.length > 1) {
            $('#bk_teaser_slider').owlCarousel({
                loop: true,
                margin: 1,
                nav: true,
                pagination: false,
                navText: ['<span class="icon-left-circle"></span>', '<span class="icon-right-circle"></span>'],
                items: 1
            });
        } else {
            $('#bk_teaser_slider').owlCarousel({
                loop: false,
                margin: 1,
                nav: true,
                pagination: false,
                navText: ['<span class="icon-left-circle"></span>', '<span class="icon-right-circle"></span>'],
                items: 1
            });
        }

        setSameHeights();

        function markDays() {
            var firstDay = false;
            $('.day').each(function () {
                var dateClass = $(this).attr('class').split(/\s+/)[0];
                if (dataToColor[dateClass]) {
                    $(this).addClass(dataToColor[dateClass]);
                    if (!firstDay) {
                        firstDay = dateClass;
                    }
                }
                if ($(this).hasClass('active')) {
                    firstDay = dateClass;
                }
            });

            if (firstDay) {
                var limit = $('.bk_list').data('limit');
                if (limit <= 0) {
                    limit = 10;
                }
                var currentVisible = 0;
                $.each($('.bk_list .bk_day'), function () {
                    if ($(this).data('day') >= firstDay && currentVisible < limit) {
                        currentVisible++;
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });
                if ($('.bk_list .bk_day:first-child:hidden').length != 0) {
                    $('.bk_list_pagination .icon-left').css('display', 'block');
                } else {
                    $('.bk_list_pagination .icon-left').css('display', 'none');
                }
                if (currentVisible == 1) {
                    $('.bk_list_pagination .icon-right').css('display', 'none');
                } else {
                    $('.bk_list_pagination .icon-right').css('display', 'block');
                }
            }
        }

        let firstEventDate = ($('.bk_list .bk_day:visible:first .bk_date').parent().data('day'));
        if ($('.bk_calendar_classes').length) {
            var calendarClasses = $('.bk_calendar_classes').val().split(' ');
        }
        var foundIndex = -1;
        let dataToColor = [];
        $.each(calendarClasses, function (index, elem) {
            var date = elem.split('|');
            dataToColor[date[0]] = date[1];
        });


        $('.bk_calendar').datepicker({
            weekStart: 1,
            maxViewMode: 2,
            format: 'dd-mm-yyyy',
            startDate: new Date(),
            templates: {
                leftArrow: '<span class="icon-left"></span>',
                rightArrow: '<span class="icon-right"></span>'
            }
        }).datepicker('setDate', '0').on('changeMonth', function (e) {
            console.log('changeMonth');
            markDays();
            var uri = window.location.toString();
            //if (uri.indexOf("?") > 0) {
            //    var clean_uri = uri.substring(0, uri.indexOf("?"));
            //    window.history.replaceState({}, document.title, clean_uri);
            //}
            $('.bk_list .bk_day:visible:first .bk_date').css('margin-top', 0);
            setSameHeights();
        }).on('changeDate', function () {
            const currentDate = formDate($('.bk_calendar').datepicker('getDate'));
            window.onload = function(){
                ifDateIsBetween(currentDate)
            };

            ifDateIsBetween(currentDate)
            if($('.bk_calendar').datepicker('getDate') !== null){
                updateQueryStringParam('date', formDate($('.bk_calendar').datepicker('getDate')));
            } else{
                //updateQueryStringParam('date', formDate());
            }
            //updateQueryStringParam('event', null);
        });

        markDays();
        var foundIndex = 0;
        $(document).delegate('.bk_list_pagination .icon-left', 'click', function () {
            var firstEventDate = ($('.bk_list .bk_day:visible:first .bk_date').parent().data('day'));
            if ($('.bk_calendar_classes').length) {
                var calendarClasses = $('.bk_calendar_classes').val().split(' ');
            }

            $.each(calendarClasses, function (index, elem) {
                var date = elem.split('|');
                if (firstEventDate == date[0]) {
                    foundIndex = index;
                }
            });
            var date = calendarClasses[foundIndex - 1].split('|')[0].split('date-')[1].split('-');
            if (foundIndex == 1) {
                $('.bk_calendar').datepicker('setDate', date[2] + '-' + date[1] + '-' + date[0]);
                $('.bk_list_pagination .icon-left').css('display', 'none');
            } else if (foundIndex > 1) {
                $('.bk_calendar').datepicker('setDate', date[2] + '-' + date[1] + '-' + date[0]);
                $('.bk_list_pagination .icon-right').css('display', 'block');
            }
            setSameHeights();
        });
        $(document).delegate('.bk_list_pagination .icon-right', 'click', function () {
            var firstEventDate = ($('.bk_list .bk_day:visible:first .bk_date').parent().data('day'));
            if ($('.bk_calendar_classes').length) {
                var calendarClasses = $('.bk_calendar_classes').val().split(' ');
            }
            $.each(calendarClasses, function (index, elem) {
                var date = elem.split('|');
                if (firstEventDate == date[0]) {
                    foundIndex = index;
                }
            });
            var date = calendarClasses[foundIndex + 1].split('|')[0].split('date-')[1].split('-');
            if (foundIndex >= 0 && foundIndex < calendarClasses.length - 2) {
                $('.bk_calendar').datepicker('setDate', date[2] + '-' + date[1] + '-' + date[0]);
                $('.bk_list_pagination .icon-left').css('display', 'block');
                $('.bk_list_pagination .icon-right').css('display', 'block');
            } else if (foundIndex == calendarClasses.length - 2) {
                $('.bk_calendar').datepicker('setDate', date[2] + '-' + date[1] + '-' + date[0]);
                $(this).css('display', 'none');
            }
            setSameHeights();
        });

        var insiderParams = '&utm_campaign=referral&utm_source=website&utm_medium=employer';

        $(document).delegate('.copy-link-btn', 'click', function (e) {
            e.preventDefault();

            if (document.cookie.indexOf('insider') > -1) {
                var link = $(this).prev('.copy-link'), linkVal = link.val();

                if (linkVal.indexOf(insiderParams) < 0) {
                    link.val(linkVal + insiderParams);
                }
            }

            $('.copy-link').select();
            document.execCommand('copy');
        });

        $(document).delegate('.copy-link', 'focus', function (e) {
            e.preventDefault();
            if (document.cookie.indexOf('insider') > -1) {
                var currentLink = $(this).val();

                if (currentLink.indexOf(insiderParams) < 0) {
                    $(this).val(currentLink + insiderParams);
                }
            }
        });

        $('.tours-list__alternatives.yellow-dot a[href="#open"]').on('click', function (e) {
            e.preventDefault();
            $(this).parents('.tours-list__vendor').trigger("click");
        });

        $('.event-alternative a[href="#"]').on('click', function (e) {
            e.preventDefault();
            $(this).parents('tr').prev('tr').children('.bk_info').children('button').trigger("click");
        });

        /**
         * Check if user is logged in
         */
        if (isInsider !== null && isInsider == 'true' || $('body').hasClass('logged-in')) {
            if (document.cookie.indexOf('insider') < 0) {
                var CookieDate = new Date;
                CookieDate.setFullYear(CookieDate.getFullYear() + 10);
                document.cookie = 'insider=true; expires=' + CookieDate.toUTCString() + '; path=/';
            }
        }

        if ($('.bk_calendar').length > 0) {
            if (urlDate !== null) {
                $('.bk_calendar').datepicker('setDate', urlDate);
                if (urlEvent !== null) {
                    /**
                     * Look for the ajax calls end
                     */
                    $(document).ajaxStop(function () {
                        const targetEvent = $("#detail-" + urlEvent );
                        targetEvent.trigger('click');
                    });

                    let observer = new MutationObserver(function(mutations) {
                        const targetDetail = $("#panel-" + urlEvent );
                        if(targetDetail.length) {
                            $('html, body').animate({
                                scrollTop: $(targetDetail).offset().top
                            }, 1000);

                            observer.disconnect();
                        }
                    });

                    observer.observe(document.body, { //document.body is node target to observe
                        childList: true, //This is a must have for the observer with subtree
                        subtree: true //Set to true if changes must also be observed in descendants.
                    });
                }
            } else {
                updateQueryStringParam('date', formDate());
            }
        }

        /** New Code **/
        const data = {
             action: 'bookingkit_data',
             postId: window.postId
         }

         $.ajax(
             {
                 type: "post",
                 dataType: "json",
                 url: bookingkit_ajax_object.ajax_url,
                 data: data,
                 success: function(msg){
                     window.vendors = msg.vendors;
                     window.suspends = msg.suspends
                     renderList(msg.events);
                 }
             });

       renderList(window.events)

        /**
         * list entry point
         * render the globally available events json
         * @param events
         */
        function renderList(events) {
            let alert = $('<div/>', {
                    text: "Momentan stehen kein Daten zur Verfügung",
                    "class": "tours-list__alert"
                }),
                container = $('body:not(.search):not(.bookingkit-voucher-template) #bookingKitContainer').addClass('tours-list'),
                pagination = $('<div class="bk_list_pagination"><span class="icon-left"></span><span class="icon-right"></span></div>');

            if (typeof events === 'undefined' || events.length == 0) {
                //container.append(alert);
                return;
            }

            var items = [];
            var index = 0;
            events.forEach((item) => {
                item.times.forEach((time) => {
                    if(index>199){
                        return;
                    }
                    var item = {
                        item_id: time.id,
                        item_name: window.vendors[time.event_id].title,
                        affiliation: 'bookingkit',
                        index: index,
                        item_brand: window.vendors[time.event_id].vendor_name,
                        quantity: time.available_slots,
                        price: parseFloat(window.vendors[time.event_id].prices[0].value),
                        currency: window.vendors[time.event_id].prices[0].currency,
                        item_variant: 'Standard'
                    };
                    window.vendors[time.event_id].categories.forEach((category, index) => {
                        item['item_category'+(index>0?index+1:'')] = category.title;
                    });
                    items.push(item);
                    index++;
                });
            });
            addToDataLayer('view_item_list', {
                item_list_id: 'tours',
                item_list_name: 'Touren',
                items: items.slice(0,20)
            });


            events.forEach((item) => {
                let dateTitle = $('<div />', {
                    'data-day': 'date-' + moment(item.day).format('YYYY-MM-DD')
                });
                dateTitle.append('<div class="bk_date tours-list__date">' + moment(item.day).format("dddd") + ',  ' + moment(item.day).format("DD.MM.YYYY") + '</div>');
                container.append(dateTitle.addClass('bk_day tours-list__slot')
                    .data('day', 'date-' + moment(item.day).format("YYYY-MM-DD"))
                    .append('<ul class="tours-list__vendors">' + makeList(item.times) + '</ul>'))
            });

            container.append(pagination)
            markDays();
            setSameHeights();
        }

        /**
         * render the slots
         * @param slots
         * @returns {string}
         */
        function makeList(slots) {
            let list = '';
            slots.map((time, eventIndex) => {
                const eventId = time.event_id;
                const vendor = window.vendors[eventId];
                let percentageFree = 0,
                    mark = "",
                    availability = "",
                    startingTime = "",
                    eventLength = slots.length,
                    workload = typeof (WORKLOAD) !== 'undefined' ? WORKLOAD : 0.8;

                if (time.available_slots == 0 || time.total_slots == 0) {
                    percentageFree = 0;
                } else {
                    percentageFree = time.available_slots / time.total_slots;
                }

                if (percentageFree == 0) {
                    mark = "red";
                } else if (percentageFree > 0 && percentageFree < workload) {
                    mark = "yellow";
                } else {
                    mark = "green";
                }

                let tips = '';
                const duration = vendor.duration;

                if(moment.parseZone(time.date).format('H') <= 6){
                    startingTime = " hour-events";
                    if(eventLength === eventIndex + 1){
                        startingTime = " last-hour-events last-hour-events-" + moment.parseZone(time.date).day();
                    }
                } else{
                    startingTime = " hour-events-" + moment.parseZone(time.date).day();
                }


                list += '<li data-date-id="' +  time.id + '" data-event-id="' + eventId + '" id="detail-' + eventId + '" class="tours-list__vendor ' + mark + startingTime + '"><div class="tours-list__container">';
                list += '<input type="hidden" class="bk_link" value="' + time.checkout_url + '"/><input class="bk_link_voucher" type="hidden" value="' +  window.vendors[eventId].voucher_checkout_url + '" />';
                list += '<div class="tours-list__time" data-time="' + time.date + '">' + moment.parseZone(time.date).format('HH:mm') + ' - ' + moment.parseZone(time.date).add(duration, 'minutes').format('HH:mm') + '</div>';

                if (vendor.title.includes("Spartipp")) {
                    tips += '<div><span class="discount">Spar-tipp!</span></div>';
                }

                list += '<div class="tours-list__title">' + tips + vendor.title + '</div>';
                if (time.available_slots != 0) {
                    let text = '';
                    if(mark === 'yellow'){
                        text = 'Noch ' + time.available_slots;
                    }
                    list += '<div class="bk_info"><button class="bk_accordion"><span class="bk_info_text">' + text + '</span> <span class="icon-down"></span></button></div>'
                } else {
                    list += '<div class="bk_info"><span>Ausgebucht</span></div>'
                }
                if (mark !== "green" && window[mark + '_link_one'] && window[mark + '_link_one'] !== '') {
                    let currentDate = moment(time.date).format('DD-MM-YYYY');
                    let linkOne = window[mark + '_link_one']['url'].replace('?date', '?date=' + currentDate);
                    let linkOneText = window[mark + '_link_one']['title'];
                    let linkTwoOutput = '';
                    if(window[mark + '_link_two'] && window[mark + '_link_two'] !== ''){
                        let linkTwo = window[mark + '_link_two']['url'].replace('?date', '?date=' + currentDate);
                        let linkTwoText = window[mark + '_link_two']['title'];
                        linkTwoOutput = '<div class="dot"><a href="' + linkTwo + '">' + linkTwoText + '</a></div>';
                    }
                    //console.log($(alt[0]).attr('href'))
                    //console.log(moment(time.date).format('DD-MM-YYYY'))
                    //console.log($(alt[0]).attr('href').includes('?date'))
                    list += '</div><div class="tours-list__alternatives ' + mark + '-dot"><div class="dot"><a href="' + linkOne + '">' + linkOneText + '</a></div>' + linkTwoOutput + '</div>';
                    //list += '</div><div class="tours-list__alternatives ' + mark + '-dot"><div class="dot"><a href="' + link1 + '"> Alternative suchen</a></div><div class="dot"><a href="' + $(alt[1]).attr('href') + '"> Gruppenanfrage stellen</a></div></div>';
                } else {
                    list += '</div>';
                }

                list += '</li>';
            });

            return list
        }
        //renderList(events);

        if( $('.page-template-bookingkit-event-template').length > 0){
            $('.bk_slider').owlCarousel({
                loop: true,
                margin: 1,
                nav: true,
                navText: ['<span class="icon-left-circle"></span>', '<span class="icon-right-circle"></span>'],
                items: 1,
                lazyLoad: true,
                lazyLoadEager: true
            });
            $('.copy-link, .share-link').val(window.location.href);
            $('.socialsharing-link').each(function () {
                var link = $(this).attr('href');
                $(this).attr('href', link.replace('dynamic-fill', window.location.href));
            });
        }
    });


    /**
     * render details on click
     */
    $(document).on('click', '.bk_day li.tours-list__vendor', function (e) {
        if ($(this).hasClass('red')) {
            return;
        }

        if ($(e.target).parents('.tour-detail').length > 0) {
            return;
        }

        let $accButton = $(this).find('.bk_accordion');
        const bookingLink = $(this).find('.bk_link').val();
        const voucherLink = $(this).find('.bk_link_voucher').val();
        //let panel = $(this).siblings('.bkid').data('unique-id');
        $(this).toggleClass('active');
        $accButton.toggleClass('active');
        $accButton.children('span + span').toggleClass('icon-down icon-up');
        const eventId = $(this).data('event-id')
        const eventDateId = $(this).data('date-id')
        let targetVendor = vendors[eventId];
        let $self = $(this), panel = null;

        if ($(this).children('.tour-detail').length > 0) {
            panel = $(this).children('.tour-detail')
        } else {
            const details = renderDetails(targetVendor, bookingLink, voucherLink);
            panel = details.appendTo($self);
            panel.hide();

            var item = {
                item_id: eventId,
                item_name: targetVendor.title,
                affiliation: 'bookingkit',
                item_brand: targetVendor.vendor_name,
                quantity: 1,
                index: 0,
                price: parseFloat(targetVendor.prices[0].value),
                currency: targetVendor.prices[0].currency,
                item_variant: 'Standard'
            };
            targetVendor.categories.forEach((category, index) => {
                item['item_category'+(index>0?index+1:'')] = category.title;
            });
            addToDataLayer('view_item', {
                currency: item.currency,
                value: parseFloat(item.price),
                items: [item]
            });

        }

        $('.bk_slider', $(this)).owlCarousel({
            loop: true,
            margin: 1,
            nav: true,
            navText: ['<span class="icon-left-circle"></span>', '<span class="icon-right-circle"></span>'],
            items: 1,
            lazyLoad: true,
            lazyLoadEager: true,
            onInitialized: setPanelHeight,
            onRefreshed: function () {
                $('#' + panel.attr('id') + ' .bk_slider .bk_iframe').height($('#' + panel.attr('id') + ' .bk_slider').height());
                setSameHeights();
            }
        });

        function setPanelHeight() {
            //panel.parent().css('height', panel.outerHeight(true));
            setSameHeights();
            let slotDate = $self.closest('.bk_day').data('day').replace('date-', '')
            updateQueryStringParam('event', eventId);
            updateQueryStringParam('date', moment(slotDate).format('DD-MM-YYYY'));
            var eventUrl = window.location.protocol + '//' + window.location.hostname + '/veranstaltung/?eventid=' + eventId + '&dateid=' + eventDateId;
            $('.copy-link, .share-link').val(eventUrl);
            $('.socialsharing-link').each(function () {
                var link = $(this).attr('href');
                $(this).attr('href', link.replace('dynamic-fill', eventUrl));
            });
        }

        if (panel.is(':visible')) {
            panel.fadeOut();
            panel.remove();
            updateQueryStringParam('event', null);
            setSameHeights();
        } else {
            panel.find('a.bk_btn').each((i, link) => {
                $(link).attr('href' , bookingLink)
            })

            panel.find('a.bk_btn_voucher').each((i, link) => {
                $(link).attr('href' , voucherLink)
            })
            panel.fadeIn();
        }
    })

    function renderDetails(data, checkoutLink, voucherUrl) {
        let detailContainer = $('<div/>', {
                id: 'panel-' + data.id,
                "class": 'tour-detail'
            }), bookingLink = $('<a>', {
                text: 'Termin buchen',
                target: '_blank',
                //href: checkoutLink,
                rel: "bkLbLink",
                "class": "bk_btn openInIframe",
                "data-action": "addToCart"
            }),
            voucherLink = $('<a>', {
                text: 'Wertgutschein kaufen',
                target: '_blank',
                //href: voucherUrl,
                rel: "bkLbLink",
                "data-action": "addToCart",
                "class": "bk_btn_voucher openInIframe"
            }),
            price = $('<p>', {
                text: new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.prices[0].value), //+ data.prices[0].currency == 'EUR' ? '€' : data.prices[0].currency,
                "class": "bk_price"
            }),
            cta = $('<div class="tour-detail__cta">' +
                '<div class="bk_box_left"> ' +
                '</div>' +
                '<div class="bk_box_right"></div>' +
                '</div>'),
            slider = $('<div/>', {
                "class": "owl-carousel bk_slider"
            }),
            list = $('<ul>', {
                "class": 'tour-detail__list'
            }),
            description = $('<div>', {
                "class": "tour-detail__description"
            }).append(data.description);

        //description.find('p').contents().unwrap()

        data.images.map((item) => {
            $('<div class="item"><img data-src="' + item + '" alt="Event Bild" class="bk_image owl-lazy"></div>').appendTo(slider)
        })

        if (data.youtubeVideoId != "") {
            $('<div class="item"><iframe class="bk_iframe" src="https://www.youtube.com/embed/' + data.youtubeVideoId + '?&rel=0&showinfo=0" frameborder="0"></iframe></div>').appendTo(slider)
        }

        bookingLink.appendTo(cta.children('.bk_box_left'))
        voucherLink.appendTo(cta.children('.bk_box_left'))
        price.appendTo(cta.children('.bk_box_right'))
        cta.appendTo(detailContainer)
        slider.appendTo(detailContainer)
        data.highlights.map((item) => {
            list.append('<li><span class="icon-star"></span>' + item + '</li>')
        })

        list.appendTo(detailContainer)
        description.appendTo(detailContainer)
        renderSocialSharers(data).appendTo(detailContainer, checkoutLink, voucherUrl)
        return detailContainer;
    }

    function renderSocialSharers(data) {
        let
            container = $('<div/>', {
                "class": "tour-detail__sharers"
            }),
            sharerContainer = $('<div/>', {
                "class": "socialsharing-container"
            }),
            sharerUrl = 'dynamic-fill',
            title = $('<span>Termin teilen:</span>'),
            twitter = $('<a>', {
                "class": "socialsharing-link socialsharing-twitter",
                target: "_blank",
                href: "https://twitter.com/intent/tweet?text='" + data.title + "'&amp;url=" + sharerUrl,
                title: "Termin teilen auf Twitter"
            }).append( "<span class=\"icon-twitter\"></span>" ),
            facebook = $('<a>', {
                "class": "socialsharing-link socialsharing-facebook",
                target: "_blank",
                href: "https://www.facebook.com/sharer/sharer.php?u=" + sharerUrl,
                title: "Termin teilen auf Facebook"
            }).append( "<span class=\"icon-facebook\"></span>" ),
             /* whatsup = $('<a>', {
                "class": "socialsharing-link socialsharing-facebook",
                target: "_blank",
                href: "https://www.facebook.com/sharer/sharer.php?u=" + sharerUrl,
                title: "Termin teilen auf Facebook"
            }).before( "<span class=\"icon-facebook\"></span>" ),*/
            linkedin = $('<a>', {
                "class": "socialsharing-link socialsharing-linkedin",
                target: "_blank",
                href: "https://www.linkedin.com/shareArticle?mini=true&url=" + sharerUrl + "&amp;title="+ data.title,
                title: "Termin teilen auf Facebook"
            }).append( "<span class=\"icon-linkedin\"></span>" ),
            email = $('<a>', {
                "class": "socialsharing-link socialsharing-email",
                target: "_blank",
                href: "mailto:?body=" + sharerUrl,
                title: "Termin teilen per Mail"
            }).append( "<span class=\"icon-mail\"></span>" ),
            bottomLinks = $('<div class="copy-link-container">\n' +
                '                <input name="copy-link" class="copy-link" type="text" readonly><button class="copy-link-btn">Termin-Link kopieren</button>\n' +
                '            </div>\n' +
                '\n' +
                '            <a target="_blank" class="bk_btn openInIframe" rel="bkLbLink" data-action="addToCart">Termin buchen</a><a target="_blank" class="bk_btn_voucher openInIframe"  rel="bkLbLink" data-action="addToCart">Wertgutschein\n' +
                '                kaufen</a>');


            let sharers = sharerContainer
                .append(title)
                .append(twitter)
                .append(facebook)
                .append(linkedin)
                .append(email);

            return container
                .append(sharers)
                .append(bottomLinks);

    }

    function getVendor(id) {
        return vendors[id];
    }


})(jQuery);
